export default {
  sm: `
    OUR 
    TECHNOLOGY 
    SHAPES 
    THE FUTURE  
  `,
  md: `
    OUR TECHNOLOGY 
    SHAPES 
    THE FUTURE   
  `,
};
